export enum QueryParams {
  MODELSERIES = 'modelseries',
  VEHICLES = 'vehicles',
}
